(function () {
  var fmt = function (cents, cur) {
    try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  };
  function boot() {
    // header menu
    document.querySelectorAll('[data-pb-menu-btn]').forEach(function (b) {
      if (b.dataset.pbReady) return; b.dataset.pbReady = 1;
      b.addEventListener('click', function () {
        var n = document.querySelector('[data-pb-nav]'); if (n) n.classList.toggle('is-open');
      });
    });
    // countdown
    document.querySelectorAll('[data-pb-countdown]').forEach(function (el) {
      if (el.dataset.pbReady) return; el.dataset.pbReady = 1;
      var left = parseInt(el.dataset.seconds, 10) || 0;
      var h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      var p = function (n) { return String(n).padStart(2, '0'); };
      var tick = function () {
        var t = Math.max(left, 0);
        h.textContent = p(Math.floor(t / 3600)); m.textContent = p(Math.floor(t / 60) % 60); s.textContent = p(t % 60);
        left = left > 0 ? left - 1 : parseInt(el.dataset.seconds, 10) || 0;
      };
      tick(); setInterval(tick, 1000);
    });
    // product block
    document.querySelectorAll('[data-pb-product]').forEach(function (root) {
      if (root.dataset.pbReady) return; root.dataset.pbReady = 1;
      var cur = root.dataset.currency;
      var variants = JSON.parse(root.querySelector('[data-pb-variants]').textContent);
      var vid = variants.length ? variants[0].id : null;
      var qty = 1;
      var main = root.querySelector('[data-pb-main]');
      root.querySelectorAll('[data-pb-thumb]').forEach(function (b) {
        b.addEventListener('click', function () {
          main.innerHTML = b.dataset.full ? '<img src="' + b.dataset.full + '" alt="">' : '';
          root.querySelectorAll('[data-pb-thumb]').forEach(function (x) { x.classList.remove('is-on'); });
          b.classList.add('is-on');
        });
      });
      var variant = function () { return variants.filter(function (v) { return v.id == vid; })[0] || variants[0]; };
      var render = function () {
        var v = variant(); if (!v) return;
        var checked = root.querySelector('[data-pb-bundle]:checked');
        var units = checked ? parseInt(checked.dataset.units, 10) : 1;
        var paid = checked ? parseInt(checked.dataset.paid, 10) : 1;
        qty = units;
        var base = v.compare > v.price ? v.compare : v.price;
        // free units cost 1 cent at checkout (same as the original offer)
        var bundle = function (u, pd) { return v.price * pd + (u - pd); };
        root.querySelectorAll('[data-pb-bundle]').forEach(function (r) {
          var u = parseInt(r.dataset.units, 10), pd = parseInt(r.dataset.paid, 10);
          var lab = r.closest('label');
          var set = function (sel, txt) { var e = lab.querySelector(sel); if (e) e.textContent = txt; };
          set('[data-price]', fmt(bundle(u, pd), cur));
          set('[data-compare]', fmt(base * u, cur));
          set('[data-save]', fmt(base * u - bundle(u, pd), cur));
          set('[data-mini-price]', fmt(bundle(u, pd), cur));
          set('[data-mini-compare]', fmt(base * u, cur));
        });
        var total = bundle(units, paid), comp = base * units;
        var a = root.querySelector('[data-pb-atc-price]'); if (a) a.textContent = fmt(total, cur);
        var c = root.querySelector('[data-pb-atc-compare]'); if (c) c.textContent = comp > total ? fmt(comp, cur) : '';
        var pr = root.querySelector('[data-pb-price]'); if (pr) pr.textContent = fmt(v.price, cur);
        var pc = root.querySelector('[data-pb-compare]'); if (pc) pc.textContent = v.compare > v.price ? fmt(v.compare, cur) : '';
        var btn = root.querySelector('[data-pb-atc]'); if (btn) { btn.disabled = !v.available; }
        var lbl = root.querySelector('[data-pb-atc-label]'); if (lbl) lbl.textContent = v.available ? lbl.dataset.add : lbl.dataset.sold;
      };
      root.querySelectorAll('[data-pb-bundle]').forEach(function (r) { r.addEventListener('change', render); });
      var sel = root.querySelector('[data-pb-variant]');
      if (sel) sel.addEventListener('change', function () { vid = sel.value; render(); });
      render();
      var form = root.querySelector('[data-pb-form]');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var items = [{ id: variant().id, quantity: qty }];
        var club = root.querySelector('[data-pb-club]');
        if (club && club.checked && club.dataset.variant) items.push({ id: parseInt(club.dataset.variant, 10), quantity: 1 });
        var btn = root.querySelector('[data-pb-atc]'); btn.disabled = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
          .then(function () { if (window.pbCart) { btn.disabled = false; window.pbCart.refresh().then(window.pbCart.open); } else { window.location.href = '/cart'; } })
          .catch(function () { btn.disabled = false; });
      });
    });
    // sticky bar
    document.querySelectorAll('[data-pb-sticky]').forEach(function (bar) {
      if (bar.dataset.pbReady) return; bar.dataset.pbReady = 1;
      var target = document.querySelector('[data-pb-atc]');
      var show = function (on) { bar.classList.toggle('is-on', on); };
      if (target && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { show(!en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(target);
      } else { show(true); }
      var go = bar.querySelector('[data-pb-goto]');
      if (go) go.addEventListener('click', function () {
        var t = document.querySelector('[data-pb-bundles]') || target; if (t) t.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
    // compare slider
    document.querySelectorAll('[data-pb-cmp]').forEach(function (box) {
      if (box.dataset.pbReady) return; box.dataset.pbReady = 1;
      var r = box.querySelector('input');
      r.addEventListener('input', function () { box.style.setProperty('--pos', r.value + '%'); });
    });
    // review list: load more
    document.querySelectorAll('[data-pb-reviews]').forEach(function (root) {
      if (root.dataset.pbReady) return; root.dataset.pbReady = 1;
      var step = parseInt(root.dataset.step, 10) || 4;
      var cards = root.querySelectorAll('[data-pb-card]');
      var shown = step;
      var btn = root.querySelector('[data-pb-more]');
      var apply = function () {
        cards.forEach(function (c, i) { c.hidden = i >= shown; });
        if (btn) btn.hidden = shown >= cards.length;
      };
      if (btn) btn.addEventListener('click', function () { shown = cards.length; apply(); });
      var sel = root.querySelector('[data-pb-sort]');
      if (sel) sel.addEventListener('change', function () {
        var list = root.querySelector('.pb-rl__list');
        var arr = Array.prototype.slice.call(cards);
        var v = sel.value;
        arr.sort(function (a, b) {
          if (v === 'high') return (b.dataset.stars - a.dataset.stars) || (b.dataset.date - a.dataset.date);
          if (v === 'low') return (a.dataset.stars - b.dataset.stars) || (b.dataset.date - a.dataset.date);
          if (v === 'oldest') return a.dataset.date - b.dataset.date;
          return b.dataset.date - a.dataset.date;
        });
        arr.forEach(function (c) { list.appendChild(c); });
        cards = arr; apply();
      });
      apply();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
